import { connect } from 'react-redux';

import ArtifactHitCountModalComponent from
  './../Components/ArtifactHitCountModalComponent.jsx';
import { keys, uniq } from 'lodash';
import { owners } from './../helpers/modals';
import { modal as modalActions } from './../actions';
import {
  getBaselineBuildInfo,
  getModalInfoByOwner,
  getModalVisibility
} from './../reducers';

export const mapStateToProps = (state) => {
  const artifactModalInfo = getModalInfoByOwner(state, owners.artifactHitCount);
  const metric = artifactModalInfo.metric;
  const isCcf = artifactModalInfo.isCcf;
  const type = isCcf ? 'ccf' : 'ncf';
  const artHitCounts = metric ? metric[type].artHitCounts : {};

  const baselineHitCounts = artHitCounts.baseline || {};
  const hitCounts = artHitCounts.current || {};

  return {
    visible: getModalVisibility(state, owners.artifactHitCount),
    title: metric ? metric.image + ' ' + type.toUpperCase() : '',
    artifacts: uniq([...keys(baselineHitCounts), ...keys(hitCounts)]).sort(),
    baselineHitCounts,
    hitCounts,
    scanKey: metric && metric.scanKey ? metric.scanKey : '',
    isExpectedBaseline: getBaselineBuildInfo(state).buildType === 'Expected',
    diffOnly: artifactModalInfo.diffOnly,
    isCcf
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    setDiffOnly: diffOnly =>
      dispatch(modalActions.setArtifactHitCountModalDiffOnly(diffOnly)),
    onHide: () => dispatch(modalActions.showArtifactHitCountModal(false)),
    openConfirm: (scanKey, isCcf, art, delta) => {
      if (!scanKey) {
        return;
      }

      dispatch(modalActions.showJiraConfirmModal(
        true, [scanKey], { [isCcf ? 'ccf' : 'ncf']: true }, art, delta)
      );
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactHitCountModalComponent);


// WEBPACK FOOTER //
// src/Containers/ArtifactHitCountModalContainer.jsx